import React from 'react';

import Doc from 'assets/svgs/ext/doc.svg';
import JPG from 'assets/svgs/ext/jpg.svg';
import PDF from 'assets/svgs/ext/pdf.svg';
import PNG from 'assets/svgs/ext/png.svg';
import SVG from 'assets/svgs/ext/svg.svg';
import ZIP from 'assets/svgs/ext/zip.svg';
import {ReactComponent as FolderSVG} from 'assets/svgs/file-upload/folder-svg.svg';

export const getFileIcon = (post, preview, border) => {
  const name = post && post.name ? post.name : '';
  const ext = name.split('.').pop().toLowerCase();

  if (preview)
    return (
      <img
        alt=""
        src={preview}
        height={30}
        width={30}
        className={`mr-2 object-fit-contain ${border ? 'border' : ''}`}
        onError={(e) => {
          e.target.src = PNG;
        }}
      />
    );

  switch (ext) {
    case 'pdf':
      return (
        <img
          alt=""
          src={PDF}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'docx':
    case 'doc':
    case 'xls':
    case 'xlsx':
      return (
        <img
          alt=""
          src={Doc}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );

    case 'mp3':
    case 'ogg':
    case 'wav':
    case 'mp4':
    case 'mov':
      return (
        <img
          alt=""
          src={File}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'zip':
    case '7z':
    case 'rar':
      return (
        <img
          alt=""
          src={ZIP}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'jpg':
    case 'jpeg':
    case 'webp':
      return (
        <img
          alt=""
          src={JPG}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'png':
      return (
        <img
          alt=""
          src={PNG}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    case 'svg':
      return (
        <img
          alt=""
          src={SVG}
          height={post.isOuter ? 30 : 25}
          className="mr-2"
        />
      );
    default:
      return (
        <FolderSVG
          color={post && post.colour ? post.colour : '#fcd297'}
          className="mr-2"
          height={30}
        />
      );
  }
};

export const getFileIconPath = (post, postName, url) => {
  const name = postName || post.name;
  const ext = name.split('.').pop().toLowerCase();

  switch (ext) {
    case 'pdf':
      return PDF;

    case 'docx':
    case 'doc':
    case 'xls':
    case 'xlsx':
      return Doc;

    case 'mp3':
    case 'ogg':
    case 'wav':
    case 'mp4':
    case 'mov':
      return File;
    case 'zip':
    case '7z':
    case 'rar':
      return ZIP;
    case 'jpg':
    case 'jpeg':
    case 'webp':
    case 'png':
    case 'svg':
      return url;
    default:
      return url;
  }
};
